/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SalesPeriod
 */
export interface SalesPeriod {
  /**
   *
   * @type {Date}
   * @memberof SalesPeriod
   */
  salesPeriodStartDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof SalesPeriod
   */
  salesPeriodEndDate?: Date;
}

export function SalesPeriodFromJSON(json: any): SalesPeriod {
  return SalesPeriodFromJSONTyped(json, false);
}

export function SalesPeriodFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesPeriod {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    salesPeriodStartDate: !exists(json, "salesPeriodStartDate")
      ? undefined
      : new Date(json["salesPeriodStartDate"]),
    salesPeriodEndDate: !exists(json, "salesPeriodEndDate")
      ? undefined
      : new Date(json["salesPeriodEndDate"]),
  };
}

export function SalesPeriodToJSON(value?: SalesPeriod | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    salesPeriodStartDate:
      value.salesPeriodStartDate === undefined
        ? undefined
        : value.salesPeriodStartDate.toISOString(),
    salesPeriodEndDate:
      value.salesPeriodEndDate === undefined
        ? undefined
        : value.salesPeriodEndDate.toISOString(),
  };
}
